import type {Moment} from 'moment-timezone'
import moment from 'moment-timezone'

export const dayStart = (date: Moment | Date) => moment(date).startOf('day').utc()
export const dayEnd = (date: Moment | Date) => moment(date).endOf('day').utc()
